<template>
    <div class="add" :class="`add-box${type}`" @click="click" :style="`width: ${width}px;height: ${height}px;line-height: ${height}px`" :disabled="showLoading">
        <span class="btn-info" :style="`line-height: ${size}px;font-size: ${size}px`">
            {{info}}
            <i class="el-icon-loading" v-if="showLoading"></i>
        </span>
    </div>
</template>
<script>
    export default {
        props: {
            info: {
                type: String,
                default: ''
            },
            type: {
                type: Number,
                default: 0
            },
            width: {
                type: Number,
                default: 96
            },
            height: {
                type: Number,
                default: 40
            },
            size: {
                type: Number,
                default: 14
            },
            showLoading: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            click() {
                this.$emit('click');
            }
        }
    }
</script>
<style scoped>
.add {
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    border-radius: 2px;
    display: inline-block;
    box-sizing: border-box;
    font-size: 0;
}
.btn-info {
    display: inline-block;
    vertical-align: middle;
}
.btn-info.el-icon-loading {
    animation: rotating 2s linear infinite;
}
.add-box0 {
    vertical-align: top;
    box-sizing: border-box;
    background: #789AFF;
    color: #fff;
}
.add-box1 {
    vertical-align: top;
    box-sizing: border-box;
    background: #FFF;
    color: #789AFF;
    border: 1px solid;
}
.add-box2 {
    vertical-align: top;
    box-sizing: border-box;
    background: #FFF;
    color: #9B9B9B;
    border: 1px solid;
}
.add-box3 {
    vertical-align: top;
    box-sizing: border-box;
    color: #999;
    background-color: rgb(0, 0, 0, .05);
    box-shadow: none;
    border: 1px solid;
}
</style>


// WEBPACK FOOTER //
// src/components/Button.vue